import { Directions, AvoidedWay, isEqual } from "./primitives";
import { BicyleCostingOptions } from "./valhalla";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { atomWithHash } from "./atomWithHash";
import { splitAtom } from "jotai/utils";

const mapStateAtom = atomWithStorage("map", {
	zoom: 16,
	center: [40.7433, -73.9196],
} as {
	zoom?: number;
	center?: [number, number];
});

export { mapStateAtom };

const costingState = atomWithHash("costing", {
	use_bikepaths: 1,
	use_oneways: 0,
	use_roads: 0.5,
} as BicyleCostingOptions);

export { costingState };

const calibrations = atomWithStorage("calibrations", [] as Directions[]);

const currentDirections = atomWithHash<Directions | null>(
	"currentDirections",
	null
);

const isCalibratedAtom = atom((get) => {
	const current = get(currentDirections);
	const calibrates = get(calibrations);
	if (current) {
		return !!calibrates.find((dir) => isEqual(dir, current));
	}
	return false;
});

export { calibrations, currentDirections, isCalibratedAtom };

const calibrationsStateAtoms = splitAtom(calibrations);

export { calibrationsStateAtoms };

const avoidsState = atomWithStorage("avoids", [] as AvoidedWay[]);

export { avoidsState };

const editingAvoidsState = atom(false);

export { editingAvoidsState };
